import { ReportsApi,  } from "api";
import {  useQuery } from "react-query"


export const useReports = () => {
  return useQuery("reports", ReportsApi, {
    refetchOnWindowFocus: false,
  })
}
